<template>
    <div class="talent-level-container">
        <div class="list-wrap">
          <div>
                <span class="fleft">优惠券过期提醒 跳转链接配置</span>
                <div  class="fleft" style="margin-right:10px">
                  <el-select v-model="couponLink.linkType" placeholder="请选择" size="mini" style="width: 150px;">
                      <el-option
                              v-for="item in options"
                              :key="item.linkType"
                              :label="item.title"
                              :value="item.linkType">
                      </el-option>
                  </el-select>
                  <span v-if="couponLink.linkType==172 || couponLink.linkType==146 ||couponLink.linkType==91">
                      <span style="margin-left: 10px">ID</span>
                      <el-input style="width: 150px;" v-model="couponLink.linkValue" size="mini"></el-input>
                  </span>
                </div>
              <button class="button is-success" @click="saveLink">保存跳转链接</button>
          </div>
            <div class="block width-1 fleft">
                <button class="button is-success" @click="showDialog">创建推送</button>
            </div>
            <div class="fleft" v-if="canSetWhiteList">
              <p v-if="isUsingWhiteList" style="color:red;font-size:20px;">白名单用户测试中！仅内部测试人员可收到推送</p>
              <p v-else style="color:red;font-size:20px;">白名单功能已关闭（内部测试用）</p>
              <a target="_blank" href="/admin.php?method=config.show&type=86">点击查看></a>
            </div>
            <div class="clearfix">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
            <div class="tile is-parent">
                <article class="tile is-child box">
                    <table class="table is-bordered">
                        <thead>
                        <tr>
                            <th>发送时间</th>
                            <th>ID</th>
                            <th>活动名称</th>
                            <th>券的定义ID</th>
                            <th>当前状态</th>
                            <th style="min-width: 130px;">累计发送数</th>
                            <th style="min-width: 130px;">累计点击数</th>
                            <th style="min-width: 130px;">点击用户数</th>
                            <th style="min-width: 80px;">点击率</th>
                            <th>活动说明预览</th>
                            <th>备注</th>
                            <th>操作人</th>
                            <th>操作</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in list">
                            <td>{{item.sendTime | getTimeStr}}</td>
                            <td>{{item.pushId}}</td>
                            <td>
                                <span v-if="item.model === 0">{{item.name}}</span>
                                <span v-if="item.model === 5">照片新增提醒</span>
                            </td>
                            <td>{{item.couponDefinitionId}}</td>
                            <td>{{item.status | getStatus}}</td>
                            <td>{{item.sentMiniProgramCount}}</td>
                            <td>{{item.miniProgramClickCount}}</td>
                            <td>{{item.miniProgramClickUserCount}}</td>
                            <td>
                                <span v-if="item.sentMiniProgramCount>0">{{(item.miniProgramClickUserCount/item.sentMiniProgramCount*100).toFixed(2)}}%</span>
                                <span v-else>0.00%</span>
                            </td>
                            <td>
                              <span v-for="(itemAct, index) in item.activityExplain" :key="index">{{itemAct.info == '1' ? '888' : ''}}{{itemAct.info == '0' ? '666' : ''}}{{itemAct.info != '1' && itemAct.info != '0' ? itemAct.info : ''}}</span>
                            </td>
                            <td>
                                <p v-if="item.model === 0" class="text-ellipsis">{{item.remark}}</p>
                                <p v-if="item.model === 5" class="text-ellipsis">{{item.tips}}</p>
                            </td>
                            <td>{{item.operatorName}}</td>
                            <td>
                                <button class="button is-danger" v-if="item.status == 0" @click="removePush(index)">删除</button>
                                <button class="button is-info" v-if="item.status > 0" @click="look(index)">查看</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </article>
            </div>
            <div class="clearfix">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
        </div>
        <el-dialog  title="创建推送"
                    :visible.sync="visible"
                    @close="closeDialog"
                    width="50%">
            <el-form label-position="right" label-width="100px">
                <el-form-item label="选择模板">
                    <el-radio-group v-model="modal.model">
                        <el-radio :label="0">活动加入成功提醒</el-radio>
                        <el-radio :label="5">照片新增提醒</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="发送时间">
                    <el-date-picker
                            :disabled="!!modal.couponDefinitionId"
                            v-model="modal.sendTime"
                            type="datetime"
                            format="yyyy-MM-dd HH:mm"
                            placeholder="选择推送时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="券的定义ID" v-if="modal.model == 0">
                  <el-input :disabled="!!modal.sendTime" style="width: 220px;" v-model="modal.couponDefinitionId" placeholder="请输入券的定义ID"></el-input>
                  <p style="color:red;font-size:12px;line-height:24px;">填写券的定义ID后请不要填写时间，系统自动判断券的定义ID开始时间作为推送时间</p>
                </el-form-item>
                <template v-if='modal.model==0'>
                    <el-form-item label="活动时间">
                        <el-input style="width: 420px;" v-model="modal.activityEndTime" placeholder="输入活动时间"></el-input>
                    </el-form-item>
                    <el-form-item label="活动名称">
                        <el-input style="width: 420px;" v-model="modal.name"></el-input>
                    </el-form-item>
                    <el-form-item label="用户ID">
                        <el-input style="width: 420px;" :rows="4" type="textarea" v-model="modal.userIds" placeholder="可回车手动换行 添加多个"></el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input :disabled="!!modal.couponDefinitionId" style="width: 420px;" :rows="4" type="textarea" v-model="modal.remark" placeholder="多行文字 可回车手动换行"></el-input>
                    </el-form-item>
                </template>
                <template v-if="modal.model==5">
                    <el-form-item label="相册名">
                        <el-input style="width: 420px;" v-model="modal.name"></el-input>
                    </el-form-item>
                    <el-form-item label="添加时间">
                        <el-input style="width: 420px;" v-model="modal.time"></el-input>
                    </el-form-item>
                    <el-form-item label="用户ID">
                        <el-input style="width: 420px;" :rows="4" type="textarea" v-model="modal.userIds" placeholder="可回车手动换行 添加多个"></el-input>
                    </el-form-item>
                    <el-form-item label="温馨提示">
                        <el-input style="width: 420px;" :rows="4" type="textarea" v-model="modal.tips" placeholder="多行文字 可回车手动换行"></el-input>
                    </el-form-item>
                </template>

                <el-form-item label="活动说明" v-if="modal.couponDefinitionId &&  modal.model == 0">
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                      <p>选择【属性】系统自动计算出属性值+文本内容进行推送文案。【属性】+的是【文本】控件，反之加的是【属性】控件。</p>
                    </div>
                    <i style="margin-right:10px;margin-top:12px;float:left;" class='fa fa-question-circle'></i>
                  </el-tooltip>
                  <div v-for="(itemAct, index) in modal.activityExplain" :key="index">
                    <div v-if="itemAct.type == 1" style="margin-bottom:10px;">
                      <el-select v-model="modal.activityExplain[index].info" placeholder="请选择"  style="width: 180px; margin-right:10px;">
                          <el-option
                            v-for="item in activityInfo"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                          </el-option>
                      </el-select>
                      <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="onDelete(index)"></el-button>
                      <el-button type="primary" icon="el-icon-plus" size="mini" circle @click="onAdd(index)"></el-button>
                    </div>
                    <div v-if="itemAct.type == 0" style="margin-bottom:10px;">
                      <el-input style="width: 300px; margin-right:10px;" autosize type="textarea" v-model="modal.activityExplain[index].info"></el-input>
                      <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="onDelete(index)"></el-button>
                      <el-button type="primary" icon="el-icon-plus" size="mini" circle @click="onAdd(index)"></el-button>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item label="活动说明预览" v-if="modal.couponDefinitionId && modal.model == 0">
                    <p style="width: 420px;">
                      <span v-for="(item, index) in modal.activityExplain" :key="index">{{item.info == '1' ? '888' : ''}}{{item.info == '0' ? '666' : ''}}{{item.info != '1' && item.info != '0' ? item.info : ''}}</span>
                    </p>
                </el-form-item>

                <el-form-item label="跳转链接">
                    <el-select v-model="modal.linkType" placeholder="请选择"  style="width: 150px;">
                        <el-option
                                v-for="item in options"
                                :key="item.linkType"
                                :label="item.title"
                                :value="item.linkType">
                        </el-option>
                    </el-select>
                    <span v-if="modal.linkType==172 || modal.linkType==146 ||modal.linkType==91">
                        <span style="margin-left: 10px">ID</span>
                        <el-input style="width: 150px;" v-model="modal.linkValue" @focus="showTip=false" :placeholder="placeholderValue"></el-input>
                        <span v-if="showTip" class="tip" style="color: red">ID填写错误！</span>
                    </span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button v-if="!isLook" type="primary" @click="judgmentId">确 定</el-button>
      </span>
        </el-dialog>
    </div>
</template>
<script type="text/babel">
import { formatDate } from "UTILS/date";
import CustomLink from 'COMMON/DefinedLink'
export default {
  components: { CustomLink },
  data() {
    return {
      search: {
        page: 1,
        pageSize: 20,
        appId: 3
      },
      list: [],
      count: 0,
      isUsingWhiteList: false,
      whiteListUserIds: [],
      canSetWhiteList: false,
      visible: false,
      isLook: false,
      modal: {
        model: 0,
        sendTime: "",
        activityEndTime: "",
        name: "",
        userIds: "",
        remark: "",
        tips: "",
        time: "",
        linkValue: null,
        linkType: 173,
        couponDefinitionId: '',
        activityExplain: [
          {
            type: 1, // 1下拉框   0文本框
            info: '0', //  
          }
        ]
      },
      activityInfo: [
        {
          name: '当前优惠券价格',
          value: '0'
        },
        {
          name: '用户可用优惠券价格', 
          value: '1'
        }
      ],
      options: [],
      showTip: false,
      model: 0,
      couponLink:{
        linkType: '',
        linkValue: ''
      }
      
    };
  },
  watch: {
    visible() {
      if (!this.visible) {
        this.modal = {
          sendTime: "",
          name: "",
          relatedGroupBuyId: ""
        };
        this.isLook = false;
      }
    }
  },
  mounted() {
    this.getList();
    this.getExpireLink();
  },
  computed: {
    hostName() {
      if (
        location.href.indexOf("local") > -1 ||
        location.href.indexOf("apitest") > -1
      ) {
        return "https://apitest.ichuanyi.com";
      } else {
        return "https://ichuanyi.com";
      }
    },
    placeholderValue() {
      if (this.modal.linkType === 172) {
        return "请输入活动ID";
      } else if (this.modal.linkType === 146) {
        return "请输入主题ID";
      } else if (this.modal.linkType === 91) {
        return "请输入单品卡片ID";
      }
    }
  },
  methods: {
    handleCurrentChange(value) {
      if (this.search.page !== value) {
        this.search.page = value;
        this.getList();
      }
    },
    saveLink() {
      HttpRequest.get(
        "/admin.php?method=wechatpusher.saveCouponExpireLink",
        {
          linkType: this.couponLink.linkType,
          linkValue: this.couponLink.linkValue
        }
      ).then(response => {
        if (response.data.success) {
          this.$message('保存成功！')
        } else {
          this.$message('请填写icy小程序相关链接')
        }
      });
    },
    getExpireLink() {
      HttpRequest.get(
        "/admin.php?method=wechatpusher.getCouponExpireLink"
      ).then(response => {
        this.couponLink.linkType = response.data.linkType
        this.couponLink.linkValue = response.data.linkValue
      });
    },
    getList() {
      HttpRequest.get(
        "/admin.php?method=wechatpusher.getList",
        this.search
      ).then(response => {
        this.list = _.toArray(response.data.list);
        this.count = response.data.count;
        this.isUsingWhiteList = response.data.isUsingWhiteList;
        this.whiteListUserIds = response.data.whiteListUserIds;
        this.canSetWhiteList = response.data.canSetWhiteList;
        this.options = response.data.linkList;
      });
    },
    closeDialog() {
      this.modal = {
        model: 0,
        sendTime: "",
        activityEndTime: "",
        name: "",
        userIds: "",
        remark: "",
        tips: "",
        time: "",
        linkValue: null,
        linkType: 173,
        couponDefinitionId: '',
        activityExplain: [
          {
            type: 1, // 1下拉框   0文本框
            info: '0', //  
          }
        ]
      };
    },
    showDialog() {
      this.visible = true;
      this.modal = {
        model: 0,
        sendTime: "",
        activityEndTime: "",
        name: "",
        userIds: "",
        remark: "",
        tips: "",
        time: "",
        linkValue: null,
        linkType: 173,
        couponDefinitionId: '',
        activityExplain: [
          {
            type: 1, // 1下拉框   0文本框
            info: '0', //  
          }
        ]
      };
    },
    look(index) {
      this.visible = true;
      this.isLook = true;
      this.modal = {
        model: this.list[index].model,
        sendTime: formatDate(this.list[index].sendTime, "yyyy-MM-dd hh:mm"),
        activityEndTime: this.list[index].activityEndTime
          ? this.list[index].activityEndTime
          : "",
        name: this.list[index].name,
        time: this.list[index].time ? this.list[index].time : "",
        tips: this.list[index].tips ? this.list[index].tips : "",
        userIds: this.list[index].userIds,
        remark: this.list[index].remark ? this.list[index].remark : "",
        linkType: this.list[index].linkData.linkType,
        linkValue: this.list[index].linkData.linkValue,
        couponDefinitionId: this.list[index].couponDefinitionId ? this.list[index].couponDefinitionId : "",
        activityExplain: this.list[index].activityExplain
         ? [...this.list[index].activityExplain] 
         : [ { type: 1, info: '0', } ]
      };
    },
    removePush(index) {
      this.$confirm("确认删除该推送?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false
      })
        .then(() => {
          let pushId = this.list[index].pushId;
          HttpRequest.post("/admin.php?method=wechatpusher.delete", {
            pushId: pushId,
            appId: 3
          }).then(response => {
            if (response.data.success) {
              this.$message("删除成功！");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    onCreate(_params) {
      let sendTime = +new Date(this.modal.sendTime) / 1000;
      let currTime = +new Date() / 1000;
      if (sendTime < currTime) {
        this.$message("推送时间不能小于当前时间");
        return false;
      }
      let params = {
        sendTime: sendTime,
        model: this.modal.model,
        userIds: this.modal.userIds,
        linkType: this.modal.linkType,
        appId: 3,
        name: this.modal.name,
      };
      if (this.modal.model === 0) {
        Object.assign(params, {
          activityEndTime: this.modal.activityEndTime,
          remark: this.modal.remark,
          couponDefinitionId: this.modal.couponDefinitionId
        });
        if (this.modal.couponDefinitionId) {
          params.activityExplain = [...this.modal.activityExplain]
        }
      } else if (this.modal.model === 5) {
        Object.assign(params, {
          time: this.modal.time,
          tips: this.modal.tips
        });
      }
      if (_params) {
        params = Object.assign({}, params, _params);
      }
      if (this.modal.model === 0) {
        if (!this.modal.couponDefinitionId) {  
          if (!params.sendTime || !params.name.trim() || !params.linkType) {
            this.$message("请填写发送时间或活动名称或跳转链接！");
            return false;
          }
          if (this.modal.model === 0 && !params.remark.trim()) {
            this.$message("请填写备注！");
            return false;
          }
        } else if (!params.name.trim() || !params.linkType) {
          this.$message("请填写活动名称或跳转链接！");
          return false;
        }
      } else if (this.modal.model === 5) {
        if (!params.sendTime || !params.name.trim() || !params.linkType) {
          this.$message("请填写发送时间或活动名称或跳转链接！");
          return false;
        }
        if (this.modal.model === 0 && !params.remark.trim()) {
          this.$message("请填写备注！");
          return false;
        }
      }
      

      HttpRequest.post("/admin.php?method=wechatpusher.create", params).then(
        response => {
          if (response.data.success) {
            this.$message("创建成功！");
            this.visible = false;
            this.getList();
          }
        }
      );
    },
    judgmentId() {
      if (
        this.modal.linkType == 172 ||
        this.modal.linkType == 146 ||
        this.modal.linkType == 91
      ) {
        let params = {
          linkType: this.modal.linkType,
          linkValue: this.modal.linkValue
        };
        HttpRequest.post(
          "/admin.php?method=wechatpusher.checkLinkTypeUseID",
          params
        ).then(response => {
          if (response.data.success) {
            this.onCreate({ linkValue: this.modal.linkValue });
          } else {
            this.showTip = true;
            return false;
          }
        });
      } else {
        this.onCreate();
      }
    },
    onDelete(index) {
      if (this.modal.activityExplain.length <= 1) {
        this.$message('至少保留一个'); 
      } else {
        this.$confirm('是否确认删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(()=>{
          this.$message('删除成功!')
          this.modal.activityExplain.splice(index,1)
        }).catch(() => {
          this.$message('已取消删除')
        });
      }
    },
    onAdd(index) {
      if (this.modal.activityExplain[index].type == 1) {
        this.modal.activityExplain.splice(index+1, 0, {
          type: 0,
          info: ''
        })
      } else if (this.modal.activityExplain[index].type == 0) {
        this.modal.activityExplain.splice(index+1, 0, {
          type: 1,
          info: '0'
        })
      }
    },
  },
  filters: {
    getStatus(status) {
      if (status == 0) {
        return "未推送";
      } else if (status == 1) {
        return "推送中";
      } else if (status == 2) {
        return "已推送";
      }
    },
    getTimeStr(time) {
      return formatDate(time, "yyyy-MM-dd hh:mm");
    }
  }
};
</script>
<style lang="less" scoped>
td {
  text-align: center;
}
.text-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  max-width: 150px;
}
</style>
